webpackJsonp([1],{

/***/ "./src recursive reducer.js":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cognito-redux/reducer.js": "./src/cognito-redux/reducer.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src recursive reducer.js";

/***/ }),

/***/ "./src recursive sagas.js":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./change-password/sagas.js": "./src/change-password/sagas.js",
	"./cognito-redux/sagas.js": "./src/cognito-redux/sagas.js",
	"./forgot-password/sagas.js": "./src/forgot-password/sagas.js",
	"./login/sagas.js": "./src/login/sagas.js",
	"./register/sagas.js": "./src/register/sagas.js",
	"./verify/sagas.js": "./src/verify/sagas.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src recursive sagas.js";

/***/ }),

/***/ "./src/app/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _login = __webpack_require__("./src/login/index.js");

var _login2 = _interopRequireDefault(_login);

var _userportal = __webpack_require__("./src/userportal/index.js");

var _userportal2 = _interopRequireDefault(_userportal);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _secureRoute = __webpack_require__("./src/secure-route/index.jsx");

var _secureRoute2 = _interopRequireDefault(_secureRoute);

var _index = __webpack_require__("./src/app/index.scss");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App() {

  return _react2.default.createElement(
    'div',
    { className: _index2.default.appWrapper },
    _react2.default.createElement(
      _reactRouterDom.Switch,
      null,
      _react2.default.createElement(_reactRouterDom.Route, { path: '/login', component: _login2.default }),
      _react2.default.createElement(_secureRoute2.default, { component: _userportal2.default })
    )
  );
};

exports.default = App;

/***/ }),

/***/ "./src/app/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appWrapper":"index__appWrapper___2NKaR"};

/***/ }),

/***/ "./src/autobind-component/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobind = __webpack_require__("./node_modules/class-autobind/lib/autobind.js");

var _classAutobind2 = _interopRequireDefault(_classAutobind);

var _reactImmutableRenderMixin = __webpack_require__("./node_modules/react-immutable-render-mixin/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Simple helper component which will autobind all functions on a component
  This is necessary becasue the reference to "this" can be lost in React components
  when you are performing callbacks from child functions.

  Additionally, this component also wraps itself in a higher-order component (HoC)
  to ensure re-renders are only performed as needed. Even though, by default,
  React will prevent rerenders if no data has changed, two objects are never equal
  unless they are references to the same objects, not just the same value.

  The react-immutable-render-mixin updates the showComponentUpdate function
  on all components (that extend this) to use the ImmutableJS built in
  comparison functions to ensure that even complex objects, so long as they are
  Immutable, will be compared on VALUE not on REFERENCES
*/
var AutobindComponent = function (_React$Component) {
  _inherits(AutobindComponent, _React$Component);

  function AutobindComponent(props) {
    _classCallCheck(this, AutobindComponent);

    var _this = _possibleConstructorReturn(this, (AutobindComponent.__proto__ || Object.getPrototypeOf(AutobindComponent)).call(this, props));

    _this.shouldUpdate = _reactImmutableRenderMixin.shouldComponentUpdate;
    (0, _classAutobind2.default)(_this);
    return _this;
  }

  _createClass(AutobindComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      // additional logic to properly re-render components if the location
      // is updated. This handles certain cases where should update isn't correct
      var location = this.props.location;


      var locationChanged = location && location.pathname !== nextProps.location.pathname;

      return locationChanged || this.shouldUpdate(nextProps, nextState);
    }
  }]);

  return AutobindComponent;
}(_react2.default.Component);

// we are default the translation function
// so we don't have to define it in tests


AutobindComponent.defaultProps = {
  t: function t(e) {
    return e;
  }
};

AutobindComponent.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  })
};

exports.default = AutobindComponent;

/***/ }),

/***/ "./src/change-password/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_NAME = exports.FORM_NAME = 'change-password';

/***/ }),

/***/ "./src/change-password/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _constants = __webpack_require__("./src/change-password/constants.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onChangePasswordFail),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function onChangePasswordFail(_ref) {
  var payload = _ref.payload;
  var errors;
  return regeneratorRuntime.wrap(function onChangePasswordFail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errors = payload.errors;
          _context.next = 3;
          return (0, _effects.put)((0, _immutable.change)(_constants.FORM_NAME, 'session', errors._error.session));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onChangePasswordSuccess() {
  _history2.default.push('/');
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_actions.changePassword.SUCCESS, onChangePasswordSuccess);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeLatest)(_actions.changePassword.FAILURE, onChangePasswordFail);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./src/cognito-redux/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.LOGOUT = exports.setPassword = exports.forgotPassword = exports.changePassword = exports.verify = exports.register = exports.login = undefined;

var _utils = __webpack_require__("./src/utils/index.js");

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

var login = exports.login = (0, _utils.createRoutine)('LOGIN');
var register = exports.register = (0, _utils.createRoutine)('REGISTER');
var verify = exports.verify = (0, _utils.createRoutine)('VERIFY');
var changePassword = exports.changePassword = (0, _utils.createRoutine)('CHANGE_PASSWORD');
var forgotPassword = exports.forgotPassword = (0, _utils.createRoutine)('FORGOT_PASSWORD');
var setPassword = exports.setPassword = (0, _utils.createRoutine)('SET_PASSWORD');

var LOGOUT = exports.LOGOUT = 'LOGOUT';

var _createActions = (0, _reduxActions.createActions)(LOGOUT),
    logout = _createActions.logout;

exports.logout = logout;

/***/ }),

/***/ "./src/cognito-redux/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorize = exports.changeUserPassword = exports.forgotUserPassword = exports.setUserPassword = exports.verifyUser = exports.signUp = exports.getCurrentUserSession = exports.currentUser = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _APP_CONFIG = __webpack_require__("APP_CONFIG");

var _classAutobind = __webpack_require__("./node_modules/class-autobind/lib/autobind.js");

var _classAutobind2 = _interopRequireDefault(_classAutobind);

var _constants = __webpack_require__("./src/cognito-redux/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
  This class uses async chunk loading to pull out the cognito identity
  libraries which make up about 1/3 of entire bundle size. This is done
  to ensure that if "main" vendor dependencies change, users won't be required
  to redownload the entire lib again
*/
var CognitoSDK = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/amazon-cognito-identity-js/lib/index.js"));

__webpack_require__("./node_modules/es6-promise/dist/es6-promise.js").polyfill();

var _pool = null;

var getPool = function getPool() {
  return CognitoSDK.then(function (_ref) {
    var CognitoUserPool = _ref.CognitoUserPool;

    if (!_pool) {
      _pool = new CognitoUserPool(_APP_CONFIG.COGNITO_POOL_DETAILS);
    }

    return _pool;
  });
};

var currentUser = exports.currentUser = function currentUser() {
  return getPool().then(function (pool) {
    return pool.getCurrentUser();
  });
};

var getCurrentUserSession = exports.getCurrentUserSession = function getCurrentUserSession() {
  return currentUser().then(function (user) {
    return new Promise(function (resolve, reject) {
      user.getSession(function (err, session) {
        if (err) {
          reject(err);
        }

        resolve(session);
      });
    });
  });
};

var _requiredAttributePresent = function _requiredAttributePresent(attribute, userAttributes, newAttributes) {
  if (userAttributes && userAttributes[attribute] !== '') {
    return true;
  }

  if (newAttributes && newAttributes[attribute] !== '') {
    return true;
  }

  return false;
};

var signUp = exports.signUp = function signUp(_ref2) {
  var username = _ref2.username,
      password = _ref2.password;

  return new Promise(function (resolve, reject) {
    Promise.all([getPool(), CognitoSDK]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          pool = _ref4[0],
          CognitoUserAttribute = _ref4[1].CognitoUserAttribute;

      var dataEmail = {
        Name: 'email',
        Value: username
      };

      var attributes = [new CognitoUserAttribute(dataEmail)];

      pool.signUp(username, password, attributes, null, function (err, result) {
        if (err) {
          return reject(err);
        }
        return resolve(result);
      });
    });
  });
};

var verifyUser = exports.verifyUser = function verifyUser(payload) {

  return new Promise(function (resolve, reject) {
    Promise.all([getPool(), CognitoSDK]).then(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          pool = _ref6[0],
          CognitoUser = _ref6[1].CognitoUser;

      var cognitoUser = new CognitoUser({
        Pool: pool,
        Username: payload.username
      });

      cognitoUser.confirmRegistration(payload.code, true, function (err, result) {
        if (err) {
          return reject(err);
        }
        return resolve(result);
      });
    });
  });
};

var setUserPassword = exports.setUserPassword = function setUserPassword(payload) {
  return new Promise(function (resolve, reject) {
    Promise.all([getPool(), CognitoSDK]).then(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          pool = _ref8[0],
          CognitoUser = _ref8[1].CognitoUser;

      var cognitoUser = new CognitoUser({
        Pool: pool,
        Username: payload.username
      });

      cognitoUser.confirmPassword(payload.verificationCode, payload.password, {
        onSuccess: function onSuccess() {
          resolve();
        },
        onFailure: function onFailure(err) {
          reject(err);
        }
      });
    });
  });
};

var forgotUserPassword = exports.forgotUserPassword = function forgotUserPassword(payload) {
  return new Promise(function (resolve, reject) {
    Promise.all([getPool(), CognitoSDK]).then(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          pool = _ref10[0],
          CognitoUser = _ref10[1].CognitoUser;

      var cognitoUser = new CognitoUser({
        Pool: pool,
        Username: payload.username
      });

      cognitoUser.forgotPassword({
        onSuccess: function onSuccess() {
          resolve(payload.username);
        },
        onFailure: function onFailure(err) {
          reject(err);
        }
      });
    });
  });
};

/**
 * Changes the current user's password.
 * @param {string} oldPassword The user's current password for authentication
 * @param {string} newPassword The desired new password
 */
var changeUserPassword = exports.changeUserPassword = function changeUserPassword(_ref11) {
  var oldPassword = _ref11.oldPassword,
      newPassword = _ref11.newPassword;


  return new Promise(function (resolve, reject) {
    currentUser().then(function (currentUser) {
      // get session otherwise the .changePassword call will fail
      currentUser.getSession(function (err) {
        if (err) {
          return reject(err);
        }
        currentUser.changePassword(oldPassword, newPassword, function (err, result) {
          if (err) {
            return reject(err);
          }
          return resolve(result);
        });
      });
    });
  });
};

var CognitoAuthorizer = function () {
  function CognitoAuthorizer(props) {
    var _this = this;

    _classCallCheck(this, CognitoAuthorizer);

    this.props = props;

    this._user = this._getUser();
    this._details = this._getDetails();

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });

    (0, _classAutobind2.default)(this);
  }

  _createClass(CognitoAuthorizer, [{
    key: '_getUser',
    value: function _getUser() {
      var _props = this.props,
          username = _props.username,
          session = _props.session;


      return Promise.all([getPool(), CognitoSDK]).then(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
            pool = _ref13[0],
            CognitoUser = _ref13[1].CognitoUser;

        var user = new CognitoUser({
          Pool: pool,
          Username: username
        });

        // TODO: Attempt authentication flow type USER_SRP_AUTH first.
        // If error occurs, handle appropriately and switch authentication flow type
        // to USER_PASSWORD_AUTH   

        user.setAuthenticationFlowType('USER_PASSWORD_AUTH');

        if (session) {
          user.Session = session;
        }
        return user;
      });
    }
  }, {
    key: '_getDetails',
    value: function _getDetails() {
      var _props2 = this.props,
          username = _props2.username,
          password = _props2.password;


      return CognitoSDK.then(function (_ref14) {
        var AuthenticationDetails = _ref14.AuthenticationDetails;


        return new AuthenticationDetails({
          Username: username,
          Password: password
        });
      });
    }
  }, {
    key: 'authorize',
    value: function authorize() {
      var _this2 = this;

      var mfaCode = this.props.mfaCode;


      return Promise.all([this._user, this._details]).then(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
            user = _ref16[0],
            details = _ref16[1];

        mfaCode ? user.sendMFACode(mfaCode, _this2) : user.authenticateUser(details, _this2);

        return _this2._promise;
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      return this._resolve(currentUser());
    }
  }, {
    key: 'onFailure',
    value: function onFailure(err) {
      return this._reject(err);
    }
  }, {
    key: 'newPasswordRequired',
    value: function newPasswordRequired(userAttributes, requiredAttributes) {
      var _this3 = this;

      var _props3 = this.props,
          newPassword = _props3.newPassword,
          attributesData = _props3.attributesData;


      if (newPassword) {
        var missingAttributes = requiredAttributes.filter(function (attr) {
          if (!_requiredAttributePresent(attr, userAttributes, attributesData)) {
            return attr;
          }
        });

        if (missingAttributes.length > 0) {
          return this._reject({
            code: _constants.ERRORS.AttributesRequired,
            attributesRequired: missingAttributes
          });
        }

        this._user.then(function (user) {
          return user.completeNewPasswordChallenge(newPassword, attributesData, _this3);
        });

        return;
      }

      return this._reject({
        code: _constants.ERRORS.NewPasswordRequired, userAttributes: userAttributes, requiredAttributes: requiredAttributes
      });
    }
  }, {
    key: 'mfaRequired',
    value: function mfaRequired() {
      var _this4 = this;

      var mfaCode = this.props.mfaCode;


      if (mfaCode) {
        this._user.then(function (user) {
          return user.sendMFACode(mfaCode);
        });
      }

      return this._user.then(function (user) {
        return _this4._reject({
          code: _constants.ERRORS.MFARequired,
          session: user.Session
        });
      });
    }
  }, {
    key: 'customChallenge',
    value: function customChallenge(e) {
      return this._reject(e);
    }
  }]);

  return CognitoAuthorizer;
}();

var authorize = exports.authorize = function authorize(props) {
  var authorizer = new CognitoAuthorizer(props);

  return authorizer.authorize();
};

/***/ }),

/***/ "./src/cognito-redux/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERRORS = exports.ERRORS = {
  NewPasswordRequired: 'NewPasswordRequired',
  PasswordAlreadySet: 'PasswordAlreadySet',
  AttributesRequired: 'AttributesRequired',
  NotAuthorizedException: 'NotAuthorizedException',
  InvalidParameterException: 'InvalidParameterException',
  MFARequired: 'MFARequired',
  InvalidPasswordException: 'InvalidPasswordException',
  UserNotFoundException: 'UserNotFoundException',
  UsernameExistsException: 'UsernameExistsException'
};

/***/ }),

/***/ "./src/cognito-redux/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCER_NAME = undefined;

var _handleActions;

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var _constants = __webpack_require__("./src/cognito-redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REDUCER_NAME = exports.REDUCER_NAME = 'cognito';

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.login.SUCCESS, function (state, _ref) {
  var payload = _ref.payload;
  return state.set('user', payload).remove('loginErrors').remove('mfa');
}), _defineProperty(_handleActions, _actions.login.FAILURE, function (state, _ref2) {
  var payload = _ref2.payload;
  return state.update('loginErrors', function () {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
    var _payload$errors$_erro = payload.errors._error,
        code = _payload$errors$_erro.code,
        attributesRequired = _payload$errors$_erro.attributesRequired,
        session = _payload$errors$_erro.session;


    return errors.set('mfaRequired', code === _constants.ERRORS.MFARequired ? (0, _immutable.fromJS)({ session: session }) : null).set('attributesRequired', code === _constants.ERRORS.AttributesRequired ? (0, _immutable.fromJS)(attributesRequired) : null).set('newPasswordRequired', code === _constants.ERRORS.NewPasswordRequired);
  });
}), _defineProperty(_handleActions, _actions.LOGOUT, function (state, _ref3) {
  var payload = _ref3.payload;

  payload.signOut();
  return state.remove('user');
}), _handleActions), (0, _immutable.Map)());

/***/ }),

/***/ "./src/cognito-redux/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _api = __webpack_require__("./src/cognito-redux/api.js");

var _utils = __webpack_require__("./src/utils/index.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleAction),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function handleAction(myAction, _ref) {
  var payload = _ref.payload;
  return regeneratorRuntime.wrap(function handleAction$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return myAction(payload.toJS());

        case 3:
          return _context.abrupt('return', _context.sent);

        case 6:
          _context.prev = 6;
          _context.t0 = _context['catch'](0);
          throw new _immutable.SubmissionError({ _error: _context.t0 });

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 6]]);
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _utils.takeLatestRoutine)(_actions.login, handleAction.bind(this, _api.authorize));

        case 2:
          _context2.next = 4;
          return (0, _utils.takeLatestRoutine)(_actions.register, handleAction.bind(this, _api.signUp));

        case 4:
          _context2.next = 6;
          return (0, _utils.takeLatestRoutine)(_actions.verify, handleAction.bind(this, _api.verifyUser));

        case 6:
          _context2.next = 8;
          return (0, _utils.takeLatestRoutine)(_actions.changePassword, handleAction.bind(this, _api.changeUserPassword));

        case 8:
          _context2.next = 10;
          return (0, _utils.takeLatestRoutine)(_actions.forgotPassword, handleAction.bind(this, _api.forgotUserPassword));

        case 10:
          _context2.next = 12;
          return (0, _utils.takeLatestRoutine)(_actions.setPassword, handleAction.bind(this, _api.setUserPassword));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./src/cognito-redux/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMFARequired = exports.selectAttributesRequired = exports.selectNewPasswordRequired = exports.selectUser = undefined;

var _reducer = __webpack_require__("./src/cognito-redux/reducer.js");

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var selectReducer = function selectReducer(state) {
  return state.get(_reducer.REDUCER_NAME);
};

var selectUser = exports.selectUser = (0, _reselect.createSelector)([selectReducer], function (reducer) {
  return reducer.get('user', null);
});

var selectLoginErrors = (0, _reselect.createSelector)([selectReducer], function (reducer) {
  return reducer.get('loginErrors', (0, _immutable.Map)());
});

var selectNewPasswordRequired = exports.selectNewPasswordRequired = (0, _reselect.createSelector)([selectLoginErrors], function (errors) {
  return errors.get('newPasswordRequired');
});

var selectAttributesRequired = exports.selectAttributesRequired = (0, _reselect.createSelector)([selectLoginErrors], function (errors) {
  return errors.get('attributesRequired');
});

var selectMFARequired = exports.selectMFARequired = (0, _reselect.createSelector)([selectLoginErrors], function (errors) {
  return errors.get('mfaRequired');
});

/***/ }),

/***/ "./src/common-hocs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactI18next = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var id = function id(e) {
  return e;
};

exports.default = function (_ref) {
  var i18n = _ref.i18n,
      redux = _ref.redux,
      _ref$router = _ref.router,
      router = _ref$router === undefined ? false : _ref$router,
      form = _ref.form;
  return function (WrappedComponent) {
    var _translate = i18n ? (0, _reactI18next.translate)(i18n) : id;
    var _connect = redux ? (0, _reactRedux.connect)(redux.mapState, redux.mapDispatch) : id;
    var _router = router ? _reactRouterDom.withRouter : id;
    var _form = form ? (0, _immutable.reduxForm)(form) : id;

    var finalHoc = (0, _redux.compose)(_form, _connect, _translate, _router);

    return finalHoc(WrappedComponent);
  };
};

/***/ }),

/***/ "./src/forgot-password/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORGOT_PASSWORD_FORM_NAME = exports.FORGOT_PASSWORD_FORM_NAME = 'forgot-password';
var SET_PASSWORD_FORM_NAME = exports.SET_PASSWORD_FORM_NAME = 'set-password';

/***/ }),

/***/ "./src/forgot-password/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _constants = __webpack_require__("./src/forgot-password/constants.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onForgotPasswordFail),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(onSetPasswordFail),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function onForgotPasswordFail(_ref) {
  var payload = _ref.payload;
  var errors;
  return regeneratorRuntime.wrap(function onForgotPasswordFail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errors = payload.errors;
          _context.next = 3;
          return (0, _effects.put)((0, _immutable.change)(_constants.FORGOT_PASSWORD_FORM_NAME, 'session', errors._error.session));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onForgotPasswordSuccess(_ref2) {
  var payload = _ref2.payload;

  _history2.default.push('/' + encodeURIComponent(payload) + '/set-password');
}

function onSetPasswordFail(_ref3) {
  var payload = _ref3.payload;
  var errors;
  return regeneratorRuntime.wrap(function onSetPasswordFail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          errors = payload.errors;
          _context2.next = 3;
          return (0, _effects.put)((0, _immutable.change)(_constants.SET_PASSWORD_FORM_NAME, 'session', errors._error.session));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function onSetPasswordSuccess() {
  _history2.default.push('/login');
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_actions.forgotPassword.SUCCESS, onForgotPasswordSuccess);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_actions.forgotPassword.FAILURE, onForgotPasswordFail);

        case 4:
          _context3.next = 6;
          return (0, _effects.takeLatest)(_actions.setPassword.SUCCESS, onSetPasswordSuccess);

        case 6:
          _context3.next = 8;
          return (0, _effects.takeLatest)(_actions.setPassword.FAILURE, onSetPasswordFail);

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/***/ }),

/***/ "./src/form-field/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/form-field/index.scss");

var _index2 = _interopRequireDefault(_index);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DemoUploadField = function DemoUploadField(_ref) {
  var _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? function (e) {
    return e;
  } : _ref$onChange;

  var finalOnChange = function finalOnChange(e) {
    var file = e.target.files[0];

    var reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = function () {
      onChange(reader.result.split(',')[1]);
    };

    reader.onerror = function (error) {
      // @TODO Replace with a nice error message?
      alert('Failed to upload file :(', error);
    };
  };

  return _react2.default.createElement('input', { type: 'file', onChange: finalOnChange });
};

DemoUploadField.propTypes = {
  onChange: _propTypes2.default.func
};

var FormField = function FormField(props) {
  var label = props.label,
      input = props.input,
      type = props.type,
      _props$meta = props.meta,
      error = _props$meta.error,
      warning = _props$meta.warning,
      touched = _props$meta.touched,
      t = props.t;


  return _react2.default.createElement(
    'div',
    { className: _index2.default.demoField },
    label ? _react2.default.createElement(
      'label',
      null,
      label
    ) : null,
    type === 'file' ? _react2.default.createElement(DemoUploadField, input) : _react2.default.createElement('input', _extends({}, input, { className: _index2.default.textbox, type: type })),
    touched && error ? _react2.default.createElement(
      'span',
      { className: _index2.default.error },
      t(error)
    ) : null,
    touched && warning ? _react2.default.createElement(
      'span',
      { className: _index2.default.warning },
      t(warning)
    ) : null
  );
};

FormField.propTypes = {
  label: _propTypes2.default.node,
  input: _propTypes2.default.any,
  type: _propTypes2.default.string,
  meta: _propTypes2.default.shape({
    error: _propTypes2.default.node,
    warning: _propTypes2.default.node
  }),
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _commonHocs2.default)({ i18n: [] })(FormField);

/***/ }),

/***/ "./src/form-field/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"demoField":"index__demoField___2cYVy","error":"index__error___jfhr1","warning":"index__warning___39nXl","textbox":"index__textbox___3U8QG"};

/***/ }),

/***/ "./src/game/game.container.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

var _game = __webpack_require__("./src/game/game.presentation.jsx");

var _game2 = _interopRequireDefault(_game);

var _selectors = __webpack_require__("./src/cognito-redux/selectors.js");

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This container file may be modified for future use

var mapState = function mapState(state) {
    return {
        user: (0, _selectors.selectUser)(state)
    };
};

var mapDispatch = {
    logout: _actions.logout
};

exports.default = (0, _commonHocs2.default)({ redux: { mapState: mapState, mapDispatch: mapDispatch }, i18n: ['game'], router: true })(_game2.default);

/***/ }),

/***/ "./src/game/game.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/game/index.scss");

var _index2 = _interopRequireDefault(_index);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindComponent = __webpack_require__("./src/autobind-component/index.jsx");

var _autobindComponent2 = _interopRequireDefault(_autobindComponent);

var _pleaserotate = __webpack_require__("./src/game/pleaserotate.js/pleaserotate.js");

var _pleaserotate2 = _interopRequireDefault(_pleaserotate);

var _constants = __webpack_require__("./src/cognito-redux/constants.js");

var _APP_CONFIG = __webpack_require__("APP_CONFIG");

var _api = __webpack_require__("./src/cognito-redux/api.js");

var _reactIframeResizerSuper = __webpack_require__("./node_modules/react-iframe-resizer-super/dist/index.js");

var _reactIframeResizerSuper2 = _interopRequireDefault(_reactIframeResizerSuper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Game = function (_AutobindComponent) {
  _inherits(Game, _AutobindComponent);

  function Game(props) {
    _classCallCheck(this, Game);

    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, props));

    var logout = props.logout,
        user = props.user;

    if (localStorage.getItem("Visited") == null) {
      localStorage.setItem("Visited", true);
    } else {
      logout(user);
      localStorage.clear();
    }

    (0, _api.getCurrentUserSession)().then(function (session) {
      var userId = session.accessToken.payload.username;
      var authToken = session.idToken.jwtToken;
      var headers = new Headers();
      headers.append("Authorization", session.idToken.jwtToken);
      return fetch(_APP_CONFIG.API_URL + "/" + ("users/" + userId + "/games"), {
        method: "get",
        headers: {
          Authorization: session.idToken.jwtToken
        }
      }).then(function (response) {
        response.json().then(function (data) {
          var ifr = document.getElementById("game");

          var deviceDetect = __webpack_require__("./node_modules/device-detect/index.js")();
          console.log(deviceDetect);
          var ifw = document.getElementById("iframeWrapper");
          if (deviceDetect.device === "Macintosh" || deviceDetect.device === "iPhone" || deviceDetect.device === "iPad" || deviceDetect.device === "iPod") {
            ifw.setAttribute("class", _index2.default.scrollWrapper);
            ifr.setAttribute("scrolling", "yes");
          }
          if (deviceDetect.browser === "Safari") {
            ifw.setAttribute("class", _index2.default.scrollWrapper);
            ifr.setAttribute("scrolling", "yes");
          }
          if (deviceDetect.device === "Android") {
            ifr.setAttribute("class", _index2.default.androidWrapper);
          }
          if (deviceDetect.device === "iPad") {
            ifw.setAttribute("class", _index2.default.iPadWrapper);
          }
          if (deviceDetect.device === "iPad") {
            ifw.setAttribute("style", "width:100vw !important");
            ifr.setAttribute("style", "width:97vw !important");
          }

          ifr.setAttribute("scrolling", "yes");
          ifr.setAttribute("allowFullScreen", "true");
          ifr.setAttribute("src", data.games[0].gameUrl + "?userId=" + userId + "&gameId=" + data.games[0].gameId + "&authtoken=" + authToken);
        });
      }, function (error) {
        error.message;
      });
    });
    return _this;
  }

  _createClass(Game, [{
    key: "componentWillMount",
    value: function componentWillMount() {

      var options = {
        onHide: function onHide() {},
        onShow: function onShow() {},
        startOnPageLoad: true,
        forcePortrait: false,
        message: "Please Rotate Your Device",
        subMessage: "(game must be landscape)",
        allowClickBypass: false,
        onlyMobile: true,
        zIndex: 1000
      };

      if (window.orientation === 0) {

        _pleaserotate2.default.start(options);
      }
    }
  }, {
    key: "render",
    value: function render() {

      var iframeResizerOptions = {
        heightCalculationMethod: "documentElementScroll",
        scrolling: true,
        checkOrigin: false,
        autoResize: false,
        bodyPadding: 0
      };
      var GameComponent = function GameComponent() {
        return _react2.default.createElement(
          "div",
          { id: "iframeWrapper" },
          _react2.default.createElement(_reactIframeResizerSuper2.default, {
            className: _index2.default.Game,
            id: "game",
            iframeResizerEnable: true,
            iframeResizerUrl: true,
            iframeResizerOptions: iframeResizerOptions
          })
        );
      };

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(GameComponent, null)
      );
    }
  }]);

  return Game;
}(_autobindComponent2.default);

Game.propTypes = {
  t: _propTypes2.default.func.isRequired,
  error: _propTypes2.default.shape({
    code: _propTypes2.default.oneOf(Object.values(_constants.ERRORS))
  })
};

exports.default = Game;

/***/ }),

/***/ "./src/game/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _game = __webpack_require__("./src/game/game.container.jsx");

var _game2 = _interopRequireDefault(_game);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _game2.default;

/***/ }),

/***/ "./src/game/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Game":"index__Game___UBSuj","scrollWrapper":"index__scrollWrapper___3F52W","iPadWrapper":"index__iPadWrapper___2nZXc","androidWrapper":"index__androidWrapper___9pxvl","scrolWrapper":"index__scrolWrapper___38EUj"};

/***/ }),

/***/ "./src/game/pleaserotate.js/pleaserotate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _screenfull = __webpack_require__("./node_modules/screenfull/dist/screenfull.js");

var _screenfull2 = _interopRequireDefault(_screenfull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {

    var PleaseRotate = {},
        currentOrientation = null,
        isMobile = /Android|iPhone|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent),
        init = false;

    var options = {
        startOnPageLoad: true,
        onHide: function onHide() {},
        onShow: function onShow() {},
        forcePortrait: false,
        message: "Please Rotate Your Device",
        subMessage: "(or click to continue)",
        allowClickBypass: true,
        onlyMobile: true,
        zIndex: 1000,
        iconNode: null
    };

    var cssRules = ["#pleaserotate-graphic { fill: #000; margin-top: 100px; margin-left: 15%; width: 70%; animation: pleaserotateframes ease 2s; animation-iteration-count: infinite; transform-origin: 50% 50%; -webkit-animation: pleaserotateframes ease 2s; -webkit-animation-iteration-count: infinite; -webkit-transform-origin: 50% 50%; -moz-animation: pleaserotateframes ease 2s; -moz-animation-iteration-count: infinite; -moz-transform-origin: 50% 50%; -ms-animation: pleaserotateframes ease 2s; -ms-animation-iteration-count: infinite; -ms-transform-origin: 50% 50%; }", "#pleaserotate-backdrop { background-color: #fae459;  color: #000; top: 0; left: 0; position: fixed; width: 100%; height: 100%; }", "#pleaserotate-container { width: 100%; position: absolute; top: 40%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); -webkit-transform: translate(-50%, -50%); }", "#pleaserotate-message {font-size: 2.3em; text-align: center; font-family: Verdana, Geneva, sans-serif; text-transform: uppercase }", "#pleaserotate-message small { opacity: .5; display: block; font-size: .8em}", "#pleaserotate-toggle-message { width=100%; font-size: 2.0em; display: block; text-align: center; font-family: Verdana, Geneva, sans-serif; text-transform: uppercase}"];

    var cssKeyframeRules = ["pleaserotateframes { 0% { transform:  rotate(0deg) ; -moz-transform:  rotate(0deg) ;-webkit-transform:  rotate(0deg) ;-ms-transform:  rotate(0deg) ;} 49% { transform:  rotate(-90deg) ;-moz-transform:  rotate(-90deg) ;-webkit-transform:  rotate(-90deg) ; -ms-transform:  rotate(-90deg) ;  } 100% { transform:  rotate(90deg) ;-moz-transform:  rotate(-90deg) ;-webkit-transform:  rotate(-90deg) ; -ms-transform:  rotate(-90deg) ;  } }"];

    /* private functions */

    function overrideOptions(updates) {
        var prop;
        for (prop in updates) {
            options[prop] = updates[prop];
        }
    }

    function setBodyClass(state) {
        if (document.documentElement) {
            document.documentElement.className = document.documentElement.className.replace(/(?:^|\s)pleaserotate-\S*/g, '');
            document.documentElement.className += " pleaserotate-" + state;
        }
    }

    function addRules(sheet) {

        var i;

        for (i = 0; i < cssRules.length; i++) {
            sheet.insertRule(cssRules[i], 0);
        }

        sheet.insertRule("#pleaserotate-backdrop { z-index: " + options.zIndex + "}", 0);

        if (options.allowClickBypass) {
            sheet.insertRule("#pleaserotate-backdrop { cursor: pointer }", 0);
        }

        if (options.forcePortrait) {
            sheet.insertRule("#pleaserotate-backdrop { -webkit-transform-origin: 50% }", 0);
        }

        for (i = 0; i < cssKeyframeRules.length; i++) {
            if (CSSRule.WEBKIT_KEYFRAMES_RULE) {
                // WebKit
                sheet.insertRule("@-webkit-keyframes " + cssKeyframeRules[i], 0);
            } else if (CSSRule.MOZ_KEYFRAMES_RULE) {
                // Mozilla
                sheet.insertRule("@-moz-keyframes " + cssKeyframeRules[i], 0);
            } else if (CSSRule.KEYFRAMES_RULE) {
                // W3C
                sheet.insertRule("@keyframes " + cssKeyframeRules[i], 0);
            }
        }
    }

    function createStyleSheet() {
        var style = document.createElement("style");
        style.appendChild(document.createTextNode("")); // I'm told we need this hack... something to do with safari but I don't feel like checking for sure
        document.head.insertBefore(style, document.head.firstChild);
        addRules(style.sheet);
    }

    function createElements() {
        var backdrop = document.createElement("div"),
            container = document.createElement("div"),
            message = document.createElement("div"),
            subMessage = document.createElement("small");
        var toggleMess = document.createElement("div");

        backdrop.setAttribute("id", "pleaserotate-backdrop");
        container.setAttribute("id", "pleaserotate-container");
        message.setAttribute("id", "pleaserotate-message");
        toggleMess.setAttribute("id", "pleaserotate-toggle-message");

        backdrop.appendChild(container);

        if (options.iconNode !== null) {
            container.appendChild(options.iconNode);
        } else {
            container.appendChild(createPhoneSVG());
        }

        container.appendChild(message);
        message.appendChild(document.createTextNode(options.message));
        subMessage.appendChild(document.createTextNode(options.subMessage));
        message.appendChild(subMessage);

        //this is added to only display on Android 
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
        if (isAndroid) {

            toggleMess.appendChild(document.createElement('br'));
            //toggleMess.appendChild(document.createElement('br'));
            toggleMess.appendChild(document.createTextNode("Android users"));
            toggleMess.appendChild(document.createElement('br'));
            toggleMess.appendChild(document.createTextNode("tap to toggle"));
            toggleMess.appendChild(document.createElement('br'));
            toggleMess.appendChild(document.createTextNode("fullscreen on/off"));
            container.appendChild(toggleMess);
        }

        document.body.appendChild(backdrop);
    }

    function createPhoneSVG() {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
        svg.setAttribute('id', 'pleaserotate-graphic');
        svg.setAttribute('viewBox', '0 0 250 250');

        var group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        group.setAttribute('id', 'pleaserotate-graphic-path');

        if (options.forcePortrait) {
            group.setAttribute('transform', 'rotate(-90 125 125)');
        }

        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M190.5,221.3c0,8.3-6.8,15-15,15H80.2c-8.3,0-15-6.8-15-15V28.7c0-8.3,6.8-15,15-15h95.3c8.3,0,15,6.8,15,15V221.3z' + 'M74.4,33.5l-0.1,139.2c0,8.3,0,17.9,0,21.5c0,3.6,0,6.9,0,7.3c0,0.5,0.2,0.8,0.4,0.8s7.2,0,15.4,0h75.6c8.3,0,15.1,0,15.2,0' + 's0.2-6.8,0.2-15V33.5c0-2.6-1-5-2.6-6.5c-1.3-1.3-3-2.1-4.9-2.1H81.9c-2.7,0-5,1.6-6.3,4C74.9,30.2,74.4,31.8,74.4,33.5z' + 'M127.7,207c-5.4,0-9.8,5.1-9.8,11.3s4.4,11.3,9.8,11.3s9.8-5.1,9.8-11.3S133.2,207,127.7,207z');
        svg.appendChild(group);
        group.appendChild(path);

        return svg;
    }

    function setVisibility(visible) {
        var backdropElement = document.getElementById("pleaserotate-backdrop");

        if (visible) {
            if (backdropElement) {
                backdropElement.style["display"] = "block";
            }
        } else {
            if (backdropElement) {
                backdropElement.style["display"] = "none";
            }
        }
    }

    function orientationChanged() {
        var triggerOn = currentOrientation && !options.forcePortrait || !currentOrientation && options.forcePortrait,
            propogate;

        if (triggerOn) {
            propogate = options.onShow();
            setBodyClass("showing");
        } else {
            propogate = options.onHide();
            setBodyClass("hiding");
        }

        if (propogate !== undefined && !propogate) {
            return;
        }

        PleaseRotate.Showing = triggerOn;
        setVisibility(triggerOn);
    }

    function isPortrait() {
        return window.innerWidth < window.innerHeight;
    }

    function checkOrientationChange() {
        if (!isMobile && options.onlyMobile) {
            if (!init) {
                init = true;
                setVisibility(false);
                setBodyClass("hiding");
                options.onHide(); // run this exactly once if not mobile
            }
            return;
        }

        if (currentOrientation !== isPortrait()) {
            currentOrientation = isPortrait();
            orientationChanged();
        }
    }

    PleaseRotate.start = function (opts) {
        if (!document.body) {
            window.addEventListener('load', PleaseRotate.start.bind(null, opts), false);
            return;
        }

        if (opts) {
            overrideOptions(opts);
        }

        createStyleSheet();
        createElements();
        checkOrientationChange();
        window.addEventListener('resize', checkOrientationChange, false);

        document.getElementById("pleaserotate-backdrop").addEventListener("click", function () {

            _screenfull2.default.toggle(document.documentElement);
        }, true);
    };
    var onWindowResize;
    PleaseRotate.stop = function () {
        window.removeEventListener('resize', onWindowResize, false);
    };

    PleaseRotate.onShow = function (fn) {
        options.onShow = fn;

        if (init) {
            // if we have already been initialized, force a check
            init = false;
            currentOrientation = null;
            checkOrientationChange();
        }
    };

    PleaseRotate.onHide = function (fn) {
        options.onHide = fn;

        if (init) {
            // if we have already been initialized, force a check so that onHide gets called
            currentOrientation = null;
            init = false;
            checkOrientationChange();
        }
    };

    PleaseRotate.Showing = false;

    /* plumbing to support AMD, CommonJS, or Globals */
    var define;
    if (typeof define === 'function' && define.amd) {
        setBodyClass("initialized");
        define(['PleaseRotate'], function () {
            return PleaseRotate;
        });
    } else if (( false ? "undefined" : _typeof(exports)) === 'object') {
        setBodyClass("initialized");
        module.exports = PleaseRotate;
    } else {
        setBodyClass("initialized");
        window.PleaseRotate = PleaseRotate;
        overrideOptions(window.PleaseRotateOptions);

        if (options.startOnPageLoad) {
            PleaseRotate.start();
        }
    }
})();

/***/ }),

/***/ "./src/header/header.container.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

var _header = __webpack_require__("./src/header/header.presentation.jsx");

var _header2 = _interopRequireDefault(_header);

var _selectors = __webpack_require__("./src/cognito-redux/selectors.js");

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapState = function mapState(state) {
  return {
    user: (0, _selectors.selectUser)(state)
  };
};

var mapDispatch = {
  logout: _actions.logout
};

exports.default = (0, _commonHocs2.default)({ router: true, redux: { mapState: mapState, mapDispatch: mapDispatch } })(_header2.default);

/***/ }),

/***/ "./src/header/header.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/header/index.scss");

var _index2 = _interopRequireDefault(_index);

var _p2p = __webpack_require__("./src/header/imgs/p2p.jpg");

var _p2p2 = _interopRequireDefault(_p2p);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  var logout = props.logout,
      user = props.user;

  {
    window.onbeforeunload = function () {
      logout(user);
      localStorage.clear();
    };
  }
  return _react2.default.createElement(
    'div',
    { className: _index2.default.headerBar },
    _react2.default.createElement('img', { src: _p2p2.default })
  );
};

Header.propTypes = {
  user: _propTypes2.default.shape({}),
  logout: _propTypes2.default.func
};

exports.default = Header;

/***/ }),

/***/ "./src/header/imgs/p2p.jpg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/p2p.e2c8e8f4b40f5ba87483b970b02580c9.jpg";

/***/ }),

/***/ "./src/header/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__("./src/header/header.container.jsx");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _header2.default;

/***/ }),

/***/ "./src/header/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerBar":"index__headerBar___19f5X"};

/***/ }),

/***/ "./src/history/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBrowserHistory = __webpack_require__("./node_modules/history/createBrowserHistory.js");

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = (0, _createBrowserHistory2.default)();

exports.default = history;

/***/ }),

/***/ "./src/history/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLocation = undefined;

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var selectReducer = function selectReducer(state) {
  return state.get('router');
};

var selectLocation = exports.selectLocation = (0, _reselect.createSelector)([selectReducer], function (reducer) {
  return reducer.location;
});

/***/ }),

/***/ "./src/i18n/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLanguage = exports.getCurrentLanguage = undefined;

var _i18next = __webpack_require__("./node_modules/i18next/dist/es/index.js");

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__("./node_modules/i18next-xhr-backend/index.js");

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this registers all files in the translations folder
// and make them available in the build. this does NOT
// actually import files, just a reference to the path
__webpack_require__("./translations recursive \\.json");

var getCurrentLanguage = exports.getCurrentLanguage = function getCurrentLanguage() {
  return _i18next2.default.language;
};

var changeLanguage = exports.changeLanguage = function changeLanguage(nextLang) {
  return _i18next2.default.changeLanguage(nextLang);
};

/**
  Here you can define your i18n configuration.
  Right now it makes two assumptions:
  1. The only allowed language is en (this is easy to change)
  2. Your translations existing at the root of the project in the translations/
     folder and are named following the convention /language-code/namespace.json
  If those two conditions are met, you only need to ensure that you define
  the correct namespaces along with your containers and you should be good
  to go.
**/
exports.default = _i18next2.default.use(_i18nextXhrBackend2.default).init({
  lng: 'en',
  whitelist: ['en'],
  ns: 'common',
  backend: {
    loadPath: 'translations/{{lng}}/{{ns}}.json',
    addPath: 'translations/{{lng}}/{{ns}}.json'
  }
});

/***/ }),

/***/ "./src/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./node_modules/regenerator-runtime/runtime.js");

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__("./src/app/index.jsx");

var _app2 = _interopRequireDefault(_app);

var _i18n = __webpack_require__("./src/i18n/index.js");

var _i18n2 = _interopRequireDefault(_i18n);

var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/es/index.js");

var _reactHotLoader = __webpack_require__("./node_modules/react-hot-loader/index.js");

var _reactI18next = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");

var _APP_CONFIG = __webpack_require__("APP_CONFIG");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

var _store = __webpack_require__("./src/store/index.js");

var _store2 = _interopRequireDefault(_store);

var _api = __webpack_require__("./src/cognito-redux/api.js");

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

__webpack_require__("./src/index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Since we need to wait for the cognito chunk to load;
  we need to wait for the store to build
*/
var asyncStore = (0, _api.currentUser)().then(function (user) {
  return (0, _store2.default)((0, _immutable.fromJS)({ cognito: { user: user } }));
});

var renderApp = function renderApp(Component) {

  asyncStore.then(function (store) {
    _reactDom2.default.render(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          _reactI18next.I18nextProvider,
          { i18n: _i18n2.default },
          _react2.default.createElement(
            _reactRouterRedux.ConnectedRouter,
            { history: _history2.default },
            _react2.default.createElement(Component, null)
          )
        )
      )
    ), document.getElementById('app'));
  });
};

renderApp(_app2.default);

if (false) {
  module.hot.accept('./app', function () {
    var NextRoot = require('./app').default;
    renderApp(NextRoot);
  });
}

window.__APP_INFORMATION = {
  version: _APP_CONFIG.VERSION,
  release: _APP_CONFIG.RELEASE
};

/***/ }),

/***/ "./src/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app":"index__app___IEf3n"};

/***/ }),

/***/ "./src/loading-spinner/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fadingCircle = __webpack_require__("./node_modules/spinkit/css/spinners/10-fading-circle.css");

var _fadingCircle2 = _interopRequireDefault(_fadingCircle);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSpinner = function LoadingSpinner(_ref) {
  var className = _ref.className;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_fadingCircle2.default["sk-fading-circle"], className) },
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle1"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle2"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle3"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle4"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle5"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle6"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle7"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle8"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle9"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle10"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle11"]) }),
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_fadingCircle2.default["sk-circle"], _fadingCircle2.default["sk-circle12"]) })
  );
};

LoadingSpinner.propTypes = {
  className: _propTypes2.default.string
};

exports.default = LoadingSpinner;

/***/ }),

/***/ "./src/login-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loginForm = __webpack_require__("./src/login-form/login-form.container.js");

var _loginForm2 = _interopRequireDefault(_loginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginForm2.default;

/***/ }),

/***/ "./src/login-form/login-form.container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

var _selectors = __webpack_require__("./src/login-form/selectors.js");

var _loginForm = __webpack_require__("./src/login-form/login-form.presentation.jsx");

var _loginForm2 = _interopRequireDefault(_loginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapState = function mapState(state, props) {
  return {
    formValues: (0, _selectors.selectFormValues)(state, props)
  };
};

exports.default = (0, _commonHocs2.default)({ form: {}, i18n: ['common', 'errors'], redux: { mapState: mapState } })(_loginForm2.default);

/***/ }),

/***/ "./src/login-form/login-form.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loadingSpinner = __webpack_require__("./src/loading-spinner/index.jsx");

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

var _styles = __webpack_require__("./src/login-form/styles.scss");

var _styles2 = _interopRequireDefault(_styles);

var _autobindComponent = __webpack_require__("./src/autobind-component/index.jsx");

var _autobindComponent2 = _interopRequireDefault(_autobindComponent);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormError = function FormError(_ref) {
  var error = _ref.error,
      t = _ref.t,
      formValues = _ref.formValues;

  if (error) {
    var errorValues = formValues ? formValues.toJS() : {};

    var finalErrorValues = _extends({}, errorValues, {
      message: error.message
    });

    return _react2.default.createElement(
      'div',
      { className: _styles2.default.errors },
      _react2.default.createElement(
        'div',
        { className: _styles2.default.error },
        t('errors:' + error.code, _extends({}, finalErrorValues))
      )
    );
  }

  return null;
};

var LoginForm = function (_AutobindComponent) {
  _inherits(LoginForm, _AutobindComponent);

  function LoginForm() {
    _classCallCheck(this, LoginForm);

    return _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).apply(this, arguments));
  }

  _createClass(LoginForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          onSubmit = _props.onSubmit,
          header = _props.header,
          submitting = _props.submitting,
          valid = _props.valid,
          children = _props.children,
          submitLabel = _props.submitLabel,
          handleSubmit = _props.handleSubmit,
          error = _props.error;


      var finalFormClassName = (0, _classnames3.default)(_styles2.default.demoForm, _defineProperty({}, _styles2.default.submitting, submitting));

      return _react2.default.createElement(
        'div',
        { className: finalFormClassName },
        header ? _react2.default.createElement(
          'h1',
          null,
          header
        ) : null,
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit(onSubmit) },
          submitting ? _react2.default.createElement(
            'div',
            { className: _styles2.default.spinner },
            _react2.default.createElement(_loadingSpinner2.default, null),
            _react2.default.createElement('br', null)
          ) : null,
          children instanceof Function ? children(this.props) : children,
          submitting ? _react2.default.createElement(
            'span',
            { className: _styles2.default.loadingText },
            t('login:logging_in')
          ) : null,
          submitLabel ? _react2.default.createElement('input', { className: _styles2.default.submitButton, type: 'submit', value: submitLabel, disabled: !valid || submitting }) : null,
          error ? _react2.default.createElement(FormError, this.props) : null
        )
      );
    }
  }]);

  return LoginForm;
}(_autobindComponent2.default);

FormError.propTypes = LoginForm.propTypes = {
  header: _propTypes2.default.node,
  onSubmit: _propTypes2.default.func.isRequired,
  submitting: _propTypes2.default.bool,
  valid: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.func]),
  form: _propTypes2.default.string.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  formValues: _propTypes2.default.any,
  error: _propTypes2.default.shape({
    code: _propTypes2.default.string,
    message: _propTypes2.default.string
  })
};

exports.default = LoginForm;

/***/ }),

/***/ "./src/login-form/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectFormValues = undefined;

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var selectFormValues = exports.selectFormValues = function selectFormValues(state, _ref) {
  var form = _ref.form;

  return (0, _immutable.getFormValues)(form)(state);
};

/***/ }),

/***/ "./src/login-form/styles.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"demoForm":"styles__demoForm___372Hc","submitButton":"styles__submitButton___2shMi","errors":"styles__errors___3zmhN","error":"styles__error___No4dN","warn":"styles__warn___1Rv-a","submitting":"styles__submitting___1x6pi","spinner":"styles__spinner___1mHfH","loadingText":"styles__loadingText___2dE34"};

/***/ }),

/***/ "./src/login/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_NAME = exports.FORM_NAME = 'login';

/***/ }),

/***/ "./src/login/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_NAME = undefined;

var _login = __webpack_require__("./src/login/login.container.jsx");

Object.defineProperty(exports, 'FORM_NAME', {
  enumerable: true,
  get: function get() {
    return _login.FORM_NAME;
  }
});

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _login2.default;

/***/ }),

/***/ "./src/login/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"index__loginPage___1uxAU","loginForm":"index__loginForm___cptU0","errorMessage":"index__errorMessage___EpUYH","links":"index__links___1RG2_","space":"index__space___10_05"};

/***/ }),

/***/ "./src/login/login.container.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

var _login = __webpack_require__("./src/login/login.presentation.jsx");

var _login2 = _interopRequireDefault(_login);

var _selectors = __webpack_require__("./src/cognito-redux/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapState = function mapState(state) {
  return {
    newPasswordRequired: (0, _selectors.selectNewPasswordRequired)(state),
    attributesRequired: (0, _selectors.selectAttributesRequired)(state),
    mfaRequired: (0, _selectors.selectMFARequired)(state)
  };
};

exports.default = (0, _commonHocs2.default)({
  i18n: ['login', 'common'],
  redux: { mapState: mapState }
})(_login2.default);

/***/ }),

/***/ "./src/login/login.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/login/index.scss");

var _index2 = _interopRequireDefault(_index);

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("./node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _formField = __webpack_require__("./src/form-field/index.jsx");

var _formField2 = _interopRequireDefault(_formField);

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _autobindComponent = __webpack_require__("./src/autobind-component/index.jsx");

var _autobindComponent2 = _interopRequireDefault(_autobindComponent);

var _loginForm = __webpack_require__("./src/login-form/index.js");

var _loginForm2 = _interopRequireDefault(_loginForm);

var _constants = __webpack_require__("./src/login/constants.js");

var _validate = __webpack_require__("./src/login/validate.js");

var _validate2 = _interopRequireDefault(_validate);

var _header = __webpack_require__("./src/header/index.jsx");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MFASection = function MFASection(_ref) {
  var t = _ref.t;

  return _react2.default.createElement(
    "fieldset",
    null,
    _react2.default.createElement(_immutable.Field, {
      required: true,
      component: _formField2.default,
      type: "text",
      name: "mfaCode",
      label: t("login:mfa_code")
    })
  );
};

var NewPasswordSection = function NewPasswordSection(_ref2) {
  var t = _ref2.t;

  return _react2.default.createElement(
    "fieldset",
    null,
    _react2.default.createElement(_immutable.Field, {
      required: true,
      component: _formField2.default,
      type: "password",
      name: "newPassword",
      label: t("login:new_password")
    })
  );
};

var LoginSection = function LoginSection(_ref3) {
  var t = _ref3.t;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_immutable.Field, {
      key: "username",
      id: "username",
      component: _formField2.default,
      type: "text",
      name: "username",
      label: t("login:username")
    }),
    _react2.default.createElement("br", { key: "linebreak" }),
    _react2.default.createElement(_immutable.Field, {
      key: "password",
      id: "password",
      component: _formField2.default,
      type: "password",
      name: "password",
      label: t("login:password")
    })
  );
};

var AdditionalAttributesSection = function AdditionalAttributesSection(_ref4) {
  var attributesRequired = _ref4.attributesRequired,
      t = _ref4.t;

  return _react2.default.createElement(
    "fieldset",
    null,
    attributesRequired.map(function (attr, i) {
      return _react2.default.createElement(
        "div",
        { key: attr + ":" + i },
        _react2.default.createElement(_immutable.Field, {
          required: true,
          component: _formField2.default,
          type: "text",
          name: "attributesData." + attr,
          label: t("login:" + attr)
        })
      );
    })
  );
};

var Login = function (_AutobindComponent) {
  _inherits(Login, _AutobindComponent);

  function Login() {
    _classCallCheck(this, Login);

    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      localStorage.clear();

      var _props = this.props,
          t = _props.t,
          newPasswordRequired = _props.newPasswordRequired,
          attributesRequired = _props.attributesRequired,
          mfaRequired = _props.mfaRequired;


      var loginRequired = !newPasswordRequired && !attributesRequired && !mfaRequired;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_header2.default, null),
        _react2.default.createElement(
          "div",
          { className: _index2.default.loginPage },
          _react2.default.createElement(
            _loginForm2.default,
            {
              onSubmit: _actions.login,
              validate: _validate2.default,
              form: _constants.FORM_NAME,
              submitLabel: t("login:login")
            },
            function (formsProps) {
              return [loginRequired ? _react2.default.createElement(LoginSection, _extends({ key: "loginSection" }, formsProps)) : null, newPasswordRequired ? _react2.default.createElement(NewPasswordSection, _extends({ key: "newPasswordSection" }, formsProps)) : null, attributesRequired ? _react2.default.createElement(AdditionalAttributesSection, _extends({
                key: "additionalAttrSection"
              }, formsProps, _this2.props)) : null, mfaRequired ? _react2.default.createElement(MFASection, _extends({ key: "mfaSection" }, formsProps)) : null];
            }
          ),
          _react2.default.createElement(
            "div",
            { className: _index2.default.links },
            _react2.default.createElement(
              "a",
              { href: "https://www.smokescreengame.org/tou", target: "_blank", without: true, rel: "noopener noreferrer" },
              "Terms of Use"
            ),
            _react2.default.createElement("div", { className: _index2.default.space }),
            _react2.default.createElement(
              "a",
              { href: "https://www.smokescreengame.org/privacy-policy", target: "_blank", without: true, rel: "noopener noreferrer" },
              "Privacy Policy"
            )
          )
        )
      );
    }
  }]);

  return Login;
}(_autobindComponent2.default);

LoginSection.propTypes = MFASection.propTypes = AdditionalAttributesSection.propTypes = NewPasswordSection.propTypes = Login.propTypes = {
  t: _propTypes2.default.func.isRequired,
  newPasswordRequired: _propTypes2.default.bool,
  attributesRequired: _propTypes2.default.arrayOf(_propTypes2.default.string),
  mfaRequired: _reactImmutableProptypes2.default.mapContains({
    session: _propTypes2.default.string.isRequired
  })
};

exports.default = Login;

/***/ }),

/***/ "./src/login/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _constants = __webpack_require__("./src/cognito-redux/constants.js");

var _constants2 = __webpack_require__("./src/login/constants.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onMFARequired),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function onMFARequired(_ref) {
  var payload = _ref.payload;
  var errors;
  return regeneratorRuntime.wrap(function onMFARequired$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errors = payload.errors;

          if (!(errors._error.code === _constants.ERRORS.MFARequired)) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return (0, _effects.put)((0, _immutable.change)(_constants2.FORM_NAME, 'session', errors._error.session));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onLoginSuccess() {
  _history2.default.push('/UserPortal');
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_actions.login.SUCCESS, onLoginSuccess);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeLatest)(_actions.login.FAILURE, onMFARequired);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./src/login/validate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (values) {
  var errors = {};

  if (!values.get('username')) {
    errors.username = 'login:username_required';
  }

  if (!values.get('password')) {
    errors.password = 'login:password_required';
  }

  if (!values.get('newPassword')) {
    errors.newPassword = 'login:new_password_required';
  }

  if (!values.get('mfaCode')) {
    errors.mfaCode = 'login:mfa_code_required';
  }

  return errors;
};

// export const usernameRequired = value => (value ? undefined : 'login:username_required');
// export const passwordRequired = value => (value ? undefined : 'login:password_required');
// export const newpassWordRequired = value => (value ? undefined : 'login:new_password_required');
// export const mfaSectionRequired = value => (value ? undefined : 'login:mfa_code_required');

/***/ }),

/***/ "./src/register/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_NAME = exports.FORM_NAME = 'register';

/***/ }),

/***/ "./src/register/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _constants = __webpack_require__("./src/register/constants.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onRegisterFail),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function onRegisterFail(_ref) {
  var payload = _ref.payload;
  var errors;
  return regeneratorRuntime.wrap(function onRegisterFail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errors = payload.errors;
          _context.next = 3;
          return (0, _effects.put)((0, _immutable.change)(_constants.FORM_NAME, 'session', errors._error.session));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onRegisterSuccess(_ref2) {
  var payload = _ref2.payload;

  _history2.default.push('/' + encodeURIComponent(payload.user.username) + '/verify');
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_actions.register.SUCCESS, onRegisterSuccess);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeLatest)(_actions.register.FAILURE, onRegisterFail);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./src/root-reducer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxImmutable = __webpack_require__("./node_modules/redux-immutable/dist/index.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/es/index.js");

var _immutable2 = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var reducerCtx = __webpack_require__("./src recursive reducer.js");

var reducers = (0, _immutable2.Map)(reducerCtx.keys().map(function (item) {
  var res = reducerCtx(item);
  return [res.REDUCER_NAME, res.default];
})).toJS();

exports.default = (0, _reduxImmutable.combineReducers)(_extends({
  router: _reactRouterRedux.routerReducer,
  form: _immutable.reducer
}, reducers));

/***/ }),

/***/ "./src/secure-route/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _secureRoute = __webpack_require__("./src/secure-route/secure-route.container.js");

var _secureRoute2 = _interopRequireDefault(_secureRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _secureRoute2.default;

/***/ }),

/***/ "./src/secure-route/secure-route.container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _secureRoute = __webpack_require__("./src/secure-route/secure-route.presentation.jsx");

var _secureRoute2 = _interopRequireDefault(_secureRoute);

var _selectors = __webpack_require__("./src/cognito-redux/selectors.js");

var _selectors2 = __webpack_require__("./src/history/selectors.js");

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapState = function mapState(state, props) {
  return {
    user: (0, _selectors.selectUser)(state, props),
    // ensures that the secure route is aware of route changes
    location: (0, _selectors2.selectLocation)(state, props)
  };
};

exports.default = (0, _commonHocs2.default)({ redux: { mapState: mapState } })(_secureRoute2.default);

/***/ }),

/***/ "./src/secure-route/secure-route.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SecureRoute = function SecureRoute(_ref) {
  var user = _ref.user,
      component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['user', 'component']);

  var Component = component;
  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, { render: function render(props) {
      return user ? _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/login' } });
    } }));
};

SecureRoute.propTypes = {
  user: _propTypes2.default.any,
  component: _propTypes2.default.any.isRequired
};

exports.default = SecureRoute;

/***/ }),

/***/ "./src/store/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rootReducer = __webpack_require__("./src/root-reducer/index.js");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reduxSaga = __webpack_require__("./node_modules/redux-saga/es/index.js");

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reduxNormalizrMiddleware = __webpack_require__("./node_modules/redux-normalizr-middleware/lib.js");

var _reduxNormalizrMiddleware2 = _interopRequireDefault(_reduxNormalizrMiddleware);

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/es/index.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

var _reduxSagaRoutines = __webpack_require__("./node_modules/redux-saga-routines/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var sagaCtx = __webpack_require__("./src recursive sagas.js");

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

var sagaMiddleware = (0, _reduxSaga2.default)();

var middlewares = [sagaMiddleware, (0, _reduxNormalizrMiddleware2.default)(), (0, _reactRouterRedux.routerMiddleware)(_history2.default)];

var defaultSagas = [].concat(_toConsumableArray(sagaCtx.keys().map(function (key) {
  return sagaCtx(key).default;
})), [_reduxSagaRoutines.routinesWatcherSaga]);

exports.default = function () {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();

  var store = (0, _redux.createStore)(_rootReducer2.default, defaultState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

  defaultSagas.map(sagaMiddleware.run);

  return store;
};

/***/ }),

/***/ "./src/userportal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userportal = __webpack_require__("./src/userportal/userportal.container.jsx");

var _userportal2 = _interopRequireDefault(_userportal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _userportal2.default;

/***/ }),

/***/ "./src/userportal/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UserPortalWrapper":"index__UserPortalWrapper___xTAjn"};

/***/ }),

/***/ "./src/userportal/userportal.container.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonHocs = __webpack_require__("./src/common-hocs/index.js");

var _commonHocs2 = _interopRequireDefault(_commonHocs);

var _userportal = __webpack_require__("./src/userportal/userportal.presentation.jsx");

var _userportal2 = _interopRequireDefault(_userportal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import { push } from 'react-router-redux';

//This container file may be modified for future use

var mapState = function mapState() {
  return {};
};

var mapDispatch = {};

exports.default = (0, _commonHocs2.default)({ redux: { mapState: mapState, mapDispatch: mapDispatch }, i18n: ['userportal'], router: true })(_userportal2.default);

/***/ }),

/***/ "./src/userportal/userportal.presentation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindComponent = __webpack_require__("./src/autobind-component/index.jsx");

var _autobindComponent2 = _interopRequireDefault(_autobindComponent);

var _index = __webpack_require__("./src/userportal/index.scss");

var _index2 = _interopRequireDefault(_index);

var _game = __webpack_require__("./src/game/index.js");

var _game2 = _interopRequireDefault(_game);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserPortal = function (_Autobind) {
  _inherits(UserPortal, _Autobind);

  function UserPortal() {
    _classCallCheck(this, UserPortal);

    return _possibleConstructorReturn(this, (UserPortal.__proto__ || Object.getPrototypeOf(UserPortal)).apply(this, arguments));
  }

  _createClass(UserPortal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { backgroundColor: "#808080" }, className: _index2.default.UserPortalWrapper },
        _react2.default.createElement(_game2.default, null)
      );
    }
  }]);

  return UserPortal;
}(_autobindComponent2.default);

UserPortal.propTypes = {
  t: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = UserPortal;

/***/ }),

/***/ "./src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRoutine = exports.mergeNormalized = exports.takeLatestRoutine = exports.selectEntities = exports.SUCCESS_POSTFIX = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _normalizr = __webpack_require__("./node_modules/normalizr/dist/src/index.js");

var _immutable = __webpack_require__("./node_modules/immutable/dist/immutable.js");

var _reduxSagaRoutines = __webpack_require__("./node_modules/redux-saga-routines/es/index.js");

var _routineStages = __webpack_require__("./node_modules/redux-saga-routines/dist/routineStages.js");

var _routineStages2 = _interopRequireDefault(_routineStages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUCCESS_POSTFIX = exports.SUCCESS_POSTFIX = 'SUCCESS';

var selectEntities = exports.selectEntities = function selectEntities(entityName) {
  return function (reducer) {
    return reducer.getIn(['entities', entityName], (0, _immutable.Map)());
  };
};

var takeLatestRoutine = exports.takeLatestRoutine = function takeLatestRoutine(routine, handler) {
  return (0, _effects.takeLatest)(routine.TRIGGER, /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
    var result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _effects.put)(routine.request());

          case 3:
            _context.next = 5;
            return handler(action);

          case 5:
            result = _context.sent;
            _context.next = 8;
            return (0, _effects.put)(routine.success(result));

          case 8:
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);
            _context.next = 14;
            return (0, _effects.put)(routine.failure(_context.t0));

          case 14:
            _context.next = 16;
            return (0, _effects.put)(routine.fulfill());

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 10]]);
  }));
};

var mergeEntities = function mergeEntities(state, newEntities, schemaKey) {
  return state.updateIn(['entities'], (0, _immutable.Map)(), function (items) {
    return items.has(schemaKey) ? items : items.set(schemaKey, (0, _immutable.Map)());
  }).updateIn(['entities'], (0, _immutable.Map)(), function (entities) {
    return entities.mergeDeep(newEntities).update(schemaKey, function (items) {
      return items.map(function (item, id) {
        return newEntities.hasIn([schemaKey, id]) ? newEntities.getIn([schemaKey, id]) : item;
      });
    });
  });
};

var mergeResults = function mergeResults(state, key, result) {
  return state.updateIn(['result', key], (0, _immutable.Set)(), function (items) {
    return items.merge(result);
  });
};

var determineSchemaKey = function determineSchemaKey(currentSchema) {
  // @TODO Extend this to support more schemas

  if (currentSchema instanceof _normalizr.schema.Array) {
    return currentSchema.schema.key;
  }

  if (Array.isArray(currentSchema)) {
    return currentSchema[0].key;
  }

  return currentSchema.key;
};

var mergeNormalized = exports.mergeNormalized = function mergeNormalized(state, action) {
  var finalPayload = (0, _immutable.fromJS)(action.payload);

  return mergeResults(mergeEntities(state, finalPayload.get('entities')), determineSchemaKey(action.meta.schema), finalPayload.get('result'));
};

var createRoutine = exports.createRoutine = function createRoutine(props) {
  var _ref = typeof props === 'string' ? { name: props } : props,
      name = _ref.name,
      metaCreator = _ref.metaCreator,
      payloadCreator = _ref.payloadCreator;

  var routine = (0, _reduxSagaRoutines.createRoutine)(name, payloadCreator);

  return Object.assign(routine, _extends({}, routine, (0, _immutable.List)(_routineStages2.default).toMap().mapKeys(function (_, item) {
    return item.toLowerCase();
  }).map(function (stage) {
    var stageName = stage.toLowerCase();
    var stageAction = routine[stageName];

    // only want to give the meta to the success action
    if (!metaCreator || stageName !== 'success') {
      return stageAction;
    }

    return function (payload) {
      var meta = typeof metaCreator === 'function' ? metaCreator(payload) : metaCreator;

      var action = stageAction(payload);

      return _extends({}, action, {
        meta: meta
      });
    };
  }).toJS()));
};

/***/ }),

/***/ "./src/verify/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_NAME = exports.FORM_NAME = 'verify';

/***/ }),

/***/ "./src/verify/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _actions = __webpack_require__("./src/cognito-redux/actions.js");

var _effects = __webpack_require__("./node_modules/redux-saga/es/effects.js");

var _immutable = __webpack_require__("./node_modules/redux-form/immutable.js");

var _constants = __webpack_require__("./src/verify/constants.js");

var _history = __webpack_require__("./src/history/index.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onVerifyFail),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function onVerifyFail(_ref) {
  var payload = _ref.payload;
  var errors;
  return regeneratorRuntime.wrap(function onVerifyFail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errors = payload.errors;
          _context.next = 3;
          return (0, _effects.put)((0, _immutable.change)(_constants.FORM_NAME, 'session', errors._error.session));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function onVerifySuccess() {
  _history2.default.push('/login');
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_actions.verify.SUCCESS, onVerifySuccess);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeLatest)(_actions.verify.FAILURE, onVerifyFail);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./translations recursive \\.json":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/changePassword.json": "./translations/en/changePassword.json",
	"./en/common.json": "./translations/en/common.json",
	"./en/errors.json": "./translations/en/errors.json",
	"./en/forgotPassword.json": "./translations/en/forgotPassword.json",
	"./en/game.json": "./translations/en/game.json",
	"./en/login.json": "./translations/en/login.json",
	"./en/register.json": "./translations/en/register.json",
	"./en/subreddit.json": "./translations/en/subreddit.json",
	"./en/upload.json": "./translations/en/upload.json",
	"./en/userportal.json": "./translations/en/userportal.json",
	"./en/verify.json": "./translations/en/verify.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./translations recursive \\.json";

/***/ }),

/***/ "./translations/en/changePassword.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/changePassword.json";

/***/ }),

/***/ "./translations/en/common.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/common.json";

/***/ }),

/***/ "./translations/en/errors.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/errors.json";

/***/ }),

/***/ "./translations/en/forgotPassword.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/forgotPassword.json";

/***/ }),

/***/ "./translations/en/game.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/game.json";

/***/ }),

/***/ "./translations/en/login.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/login.json";

/***/ }),

/***/ "./translations/en/register.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/register.json";

/***/ }),

/***/ "./translations/en/subreddit.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/subreddit.json";

/***/ }),

/***/ "./translations/en/upload.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/upload.json";

/***/ }),

/***/ "./translations/en/userportal.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/userportal.json";

/***/ }),

/***/ "./translations/en/verify.json":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "translations/en/verify.json";

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
__webpack_require__("./node_modules/whatwg-fetch/fetch.js");
module.exports = __webpack_require__("./src/index.jsx");


/***/ }),

/***/ "APP_CONFIG":
/***/ (function(module, exports) {

module.exports = {"RELEASE":1546452811915,"VERSION":"1.0.0","COGNITO_POOL_DETAILS":{"UserPoolId":"us-east-1_d6ZZDefrc","ClientId":"2k7iqfpa5p3ovajj9po27gfd8f"},"API_URL":"https://api.p2p-games.org"};

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.76cb7f96a3269f015496.js